import { isMonday, isThursday, previousMonday, previousThursday, startOfDay, subWeeks } from 'date-fns';

export const getLastMonday = (date = new Date()): Date => {
  const normalizedDate = startOfDay(date);
  return isMonday(normalizedDate) ? normalizedDate : previousMonday(normalizedDate);
};

export const getMondayOneWeekAgo = (fromDate: Date): Date => {
  return subWeeks(fromDate, 1);
};

export const getLastThursday = (date = new Date()): Date => {
  const normalizedDate = startOfDay(date);
  return isThursday(normalizedDate) ? normalizedDate : previousThursday(normalizedDate);
};

export const getThursdayOneWeekAgo = (fromDate: Date): Date => {
  return subWeeks(fromDate, 1);
};

export const getLastWeekStart = (useThursdayWeek: boolean, date = new Date()): Date =>
  useThursdayWeek ? getLastThursday(date) : getLastMonday(date);

export const getWeekStartOneWeekAgo = (useThursdayWeek: boolean, fromDate: Date): Date =>
  useThursdayWeek ? getThursdayOneWeekAgo(fromDate) : getMondayOneWeekAgo(fromDate);
